import { Box, Button } from "@mui/material";
import { Ico_Filter, Ico_Plus } from "@sagecentral/core-ui";
import { forwardRef, ForwardedRef } from "react";

type NoteListToolbarProps = {
    onAddClick: () => void;
};

const NoteListToolbar = forwardRef<HTMLButtonElement, NoteListToolbarProps>((props, ref) => {
    const { onAddClick } = props;
    
    return (
        <Box sx={{
            display: 'flex',
            marginBottom: '12px',
            marginLeft: '-8px',
            height: '40px',
            justifyContent: 'left'
        }}>
            <Button 
                color='primary' 
                variant='contained' 
                onClick={onAddClick}
                startIcon={<Ico_Plus/>}
                ref={ref}
                id="add-note-button"
            >
                Add New Note
            </Button>
        </Box>
    );
});

export default NoteListToolbar;